import React from 'react';
import { textLineBreak } from 'libs/textLineBreak';
import { Modal, Button } from 'antd';

const PrivacyText = `
㈜빅스텝에듀케이션(이하 “회사” “빅스텝에듀”)은 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에 의거한 개인정보처리방침을 정하여 “회원” 권익 보호에 최선을 다하고 있습니다.


"빅스텝에듀"는 “회원”의 개인정보를 보호하고 개인정보와 관련한 "회원"의 고충을 원활하게 처리할 수 있도록 개인정보처리방침을 제정∙시행하며, "빅스텝에듀"가 개인정보처리방침을 개정하는 경우 빅스텝에듀의 홈페이지(bigstepedu.com)에 변경 사항을 즉시 게재하거나 “회원” 개별 이메일(ID)로 공지합니다.


제1조(개인정보 수집 항목 및 이용 목적 및 수집방법)

"빅스텝에듀"는 "회원"의 동의가 있거나 법령의 규정에 의한 경우를 제외하고는 본 조에서 고지한 범위를 넘어 "회원"의 개인정보를 활용하지 않습니다. 수집한 개인정보 활용의 목적은 아래와 같습니다.


  1. 회원 관리: 회원제 서비스 이용에 따른 본인확인, 가입 의사 확인, 개인 식별, 불량 회원의 부정 이용 및 비인가 사용 방지, 가입 및 가입횟수 제한, 추후 법정 대리인 본인확인, 분쟁 조정을 위한 기록보존, 연령확인, 불만처리 등 민원 상담 처리, 고지사항 등 최신 정보 전달

  2. 서비스 제공에 관한 계약 이행 및 요금정산: 학습 서비스 및 콘텐츠 일체 제공, 서비스 요금 결제, 상품 배송, 금융서비스 제공, 요금추심 등

  3. 마케팅 및 광고에 활용: 신규 서비스 개발 및 고도화, 이벤트 등 광고성 정보 전달, 인구 통계학적 특성에 따른 서비스 제공 및 광고 게재

  4. 사고발생시 원인 규명 및 처리를 위한 수집 및 이용


제2조(개인정보 수집 항목)

최초 회원가입 시 회원식별을 위해 아래와 같은 정보를 수집합니다.

  - 항목: 성명, 이메일(ID), 비밀번호, 가입인증정보(메일주소, 휴대폰 번호), 만 14세 미만은 법정대리인 정보


원활한 고객상담과 맞춤 서비스의 제공을 위해 아래와 같은 추가적인 정보를 수집할 수 있습니다.

  - 항목: 영어 이름, 연락처(메일주소, 휴대폰 번호), 인증정보(메일주소, 휴대폰 번호), 출신 학교, 직장 및 직무, 거주지의 시간대, 메일 수신 여부, 수강정보 및 이벤트 소식 이메일 수신 여부,


부가 서비스 및 맞춤식 서비스 이용 또는 이벤트 응모 과정에서 해당 서비스의 이용자에 한해서만 이용자의 동의를 얻은 후, 다음과 같은 별도의 정보가 추가적으로 수집될 수 있습니다.

  - 대학생, 대학원생 할인: 재학증명서 또는 학생증,

  - 고객 학습 종료 후 제공되는 피드백과 녹음 및 교정 파일


서비스 이용과정이나 사업처리 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.

  - 접속 IP 정보, 쿠키, 결제기록, 접속로그, 서비스 이용 기록, 불량 이용 기록


유료 서비스 이용 과정에서 아래와 같은 결제 정보들이 수집될 수 있습니다.

  - 신용카드 결제 시: 카드사명, 카드번호, 카드 소유주 생년월일, 유효기간 등

  - 계좌 이체 시: 은행 명, 입금자 명, 계좌번호 등


회사는 다음과 같은 방법으로 개인정보를 수집합니다.

  1) 회원 가입 및 정보 수정

  2) 전화, 메신저, 오프라인 개인 상담

  3) 제휴사로부터의 제공

  4) 생성정보 수집 툴을 통한 자동 수집


제3조(개인정보의 보유 및 이용기간)

"빅스텝에듀"는 "회원"이 회원자격을 유지하고 있는 동안 수집된 "회원"의 개인 및 수강정보를 보유∙이용할 수 있으며, "회원"이 탈퇴하거나 자격을 상실할 경우에는 "회원"의 별도 요청이 없더라도 수집된 회원정보를 삭제 및 파기합니다. 단, "회원"의 탈퇴 또는 자격상실에도 불구하고 다음의 정보는 아래의 이유로 명시한 기간 동안 보존 합니다.


1. 빅스텝에듀 내부 방침에 의한 정보 보유

  - 보존 항목: 이름, 이메일 주소(ID), 전화번호, 수업 로그

  - 보존 근거: 재가입 제한 및 서비스 중복 신청 확인

  - 보존 기간: 회원 탈퇴 후 1년,


2. 관련법령에 의한 정보보유 사유

  상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.


  계약 또는 청약철회 등에 관한 기록 (소비자 식별정보, 계약∙청약철회 기록 등) - 전자상거래 등에서의 소비자보호에 관한 법률 - 5년

  대금결제 및 재화 등의 공급에 관한 기록 - 전자상거래 등에서의 소비자보호에 관한 법률 - 5년

  소비자의 불만 및 분쟁처리에 관한 기록 - 전자상거래 등에서의 소비자보호에 관한 법률 - 3년

  신용정보의 수집∙처리 및 이용 등에 관한 기록 - 신용정보의 이용 및 보호에 관한 법률 - 3년

  웹사이트 방문기록 (로그기록, IP 등) - 통신비밀보호법 - 3개월


3. 휴면회원의 정보 보유

"회원"이 마지막 접속일로부터 1년(365일) 이상 로그인을 하지 않은 경우 해당 "회원"의 아이디는 “휴면회원”이 되어 회원 로그인을 비롯한 모든 서비스에 대한 이용이 정지되고, "빅스텝에듀"는 “휴면회원”의 개인정보를 다른 아이디와 별도로 관리합니다. "빅스텝에듀"는 “휴면회원” 처리 예정일 30일 전 해당 사실을 이메일을 통하여 사전 안내하며, "회원"은 “휴면회원” 처리일 이후에 빅스텝에듀 사이트(bigstepedu.com)” 상에서 직접 본인 확인을 거쳐 휴면상태 해지신청을 하는 즉시 다시 정상적으로 서비스를 이용할 수 있습니다.


제4조(동의의 거부권 등)

"회원"은 개인정보 수집∙이용에 관한 동의를 거부할 권리가 있습니다. 다만, 계약 체결 등을 위해 필요한 최소한의 개인정보 수집∙이용에 관한 동의를 거부하는 경우에는 빅스텝에듀 콘텐츠 및 서비스 이용이 불가(본인 여부 및 계약 체결 의사 불명 이유)하고, 마케팅 활동 및 홍보를 위한 개인정보 수집∙이용 또는 선택적 수집∙이용에 관한 동의를 거부하는 경우에는 이벤트, 혜택에 대한 정보를 제공받지 못하거나 사은품∙판촉물 제공, 할인 혜택 적용 등의 불이익이 발생할 수 있습니다.


제5조(개인정보의 파기절차 및 방법)

빅스텝에듀는 원칙적으로 이용자 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 빅스텝에듀의 개인정보 파기절차 및 방법은 다음과 같습니다.


파기절차

  - “회원”이 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조)일정 기간 저장된 후 파기됩니다.- 동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.


파기기한

  개인정보의 보유기간이 경과한 경우에는 그 경과한 날로부터, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 된 경우에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 각 지체 없이(정당한 사유가 없는 한 5일 이내) 해당 개인정보를 파기합니다.


파기방법

  - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.

  - 전자파일 형태의 개인정보는 복구 및 재생이 불가능한 기술적 방법을 사용하여 삭제합니다.


제6조(회원 및 법정대리인의 권리와 그 행사방법)

1. "회원"은 언제든지 "회원"의 개인정보를 열람하거나 수정할 수 있으며, "빅스텝에듀"의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 가입해지(회원탈퇴)를 요청할 수 있습니다.


2. "회원"의 개인정보 조회 및 수정을 위해서는 “나의 정보 수정하기”를, 가입해지(동의철회)를 위해서는 "탈퇴하기(Close Account)"를 클릭하여 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은 개인정보 보호 업무 담당부서에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.


3. 만 14세 이상인 경우에만 회원 가입이 가능하며, 개인정보의 수집∙이용에 법정 대리인의 동의가 필요한 만 14세 미만 아동의 개인정보는 원칙적으로 수집하지 않습니다.


제7조(개인정보 자동수집 장치의 설치, 운영 및 거부에 관한 사항)

빅스텝에듀는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다. 이 정보는 반드시 "회원"이 정보를 제공하였을 때만 저장되고, "회원"이 제공하지 않은 정보를 얻을 수 없으며, 컴퓨터에 저장되어 있는 다른 파일들에 접근할 수 없습니다. 쿠키의 사용 목적 및 쿠키 설정 거부 방법은 다음과 같습니다.


쿠키의 사용 목적

  빅스텝에듀 회원 및 사이트 방문객들의 이용형태(접속빈도, 방문시간, 서비스 관심도)를 분석해 이용자에게 최적화된 정보를 제공하기 위하여 사용합니다.


쿠키의 설치/운영 및 거부

1. "회원"은 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, "회원"은 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. 단, "회원”이 쿠키 설치를 거부하였을 경우 로그인이 필요한 일부 서비스 제공에 어려움이 있을 수 있습니다.


2. 쿠키 설치 허용 여부를 설정하는 방법은 다음과 같습니다.

  - Internet Explorer: 웹 브라우저 상단의 도구 à 인터넷 옵션 à 개인정보

  - Google Chrome: 웹 브라우저 상단의 설정 à 고급 설정 à 개인정보


제8조(개인정보의 기술적/관리적 보호 대책)

회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다.


1. 비밀번호 관리

“회원” 아이디(ID)의 비밀번호는 본인만이 알고 있으며, 비밀번호의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.


2. 해킹 등에 대비한 대책

"빅스텝에듀"는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신 및 점검을 하며 시스템을 기술적 ・ 물리적으로 감시 및 차단하고 있습니다.


3. 취급 직원의 최소화 및 교육

회사의 개인정보관련 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 관리자 수시 교육을 통하여 빅스텝에듀 개인정보처리방침의 준수를 항상 강조하고 있습니다.


4. 내부관리계획의 수립 및 시행

개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.


5. 개인정보처리시스템 접근 제한

개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.

단, 이용자 본인의 부주의나 인터넷상의 문제로 ID, 비밀번호, 주민등록번호 등 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지 않습니다.


제9조(개인정보관리책임자 및 담당자의 연락처)

빅스텝에듀의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자께 신고하실 수 있습니다. 빅스텝에듀는 “회원”의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.


개인정보 관리책임자

  이름: 오종관

  이메일: info@bigstepedu.com


기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.

  - 개인정보침해신고센터 (www.118.or.kr / 118)

  - 정보보호마크인증위원회 (www.eprivacy.or.kr / 02-580-0533~4)

  - 대검찰청 첨단범죄수사과 (www.spo.go.kr / 02-3480-2000)

  - 경찰청 사이버테러대응센터 (www.ctrc.go.kr / 02-392-0330)


제10조(고지의 의무)

현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 고지할 것입니다.


  - 공지일자: 2020년 11월 23일

  - 시행일자: 2020년 11월 23일
`;
type TPrivacyModalProps = {
  visible: boolean;
  setVisible: any;
};
const PrivacyModal = ({ visible, setVisible }: TPrivacyModalProps) => {
  function handleCancel() {
    setVisible(false);
  }

  return (
    <Modal
      title={<strong>개인정보 처리방침</strong>}
      visible={visible}
      centered={true}
      maskClosable={true}
      closable={true}
      footer={<Button onClick={handleCancel}>닫기</Button>}
      width={800}
      onCancel={handleCancel}
    >
      {textLineBreak(PrivacyText)}
    </Modal>
  );
};

PrivacyModal.defaultProps = {};

export default PrivacyModal;
